import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useFormik } from "formik";
import toast from "react-hot-toast";

import { FaRegCircleXmark, FaPercent } from "react-icons/fa6";
import * as SVGImages from "../../svg";

import "../Asociados/createAsociados.css";
import "./createAbono.css";
import { createOrdenFormValidation } from "../../../../helper/validate";

import * as api from "helper/helper";
import "./../formsCommons.css";

import styles from "./../tooltip.module.css";
import createOrdenStyles from "./createAbono.module.css";

import { EstadoBodega } from "../../../../helper/const";
import { buildNameWithId, Singleton } from "helper/tools";
import invalidClass from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";
import AutocompleteGo from "../Autocomplete/AutocompleteGo";
import CreateClient from "../Clientes/CreateClient";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import { useTimeout } from "../../hooks/useTimeout";
import SelectBonificacion from "../Ventas/SelectBonificacion";

const CreateAbono = forwardRef(({ item, reloadOrdenes }, ref) => {
  const [metodoPagos] = useState([
    { id: 1, name: "Efectivo" },
    { id: 2, name: "MercadoPago" },
    { id: 3, name: "Pago con Tarjeta" },
  ]);

  const modalRef = useRef();
  const buttonCancelModalRef = useRef();
  const asociadoIdRef = useRef(0);

  const createClientesRef = useRef();
  const selectBonificacionRef = useRef();
  const [modalDataBonificacion, setModalDataBonificacion] = useState(null);

  const refAutocompleteAsociados = useRef(null);
  const refAutocompleteProducto = useRef(null);
  const refAutocompleteOrdenesVenta = useRef(null);
  const refAutocompleteClientes = useRef(null);

  /// CHECAR  useTraceUpdate(props, "CreateOrdenVenta");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [asociados, setAsociados] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [ordenesVenta, setOrdenesVenta] = useState([]);
  const [productos, setProductos] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [defaultOnlyAsociadoId, setDefaultOnlyAsociadoId] = useState();
  const [disableCrearAbono, setDisableCrearAbono] = useState(true);
  const [disableAgregarProducto, setDisableAgregarProducto] = useState(true);
  const [hasBonificaciones, setHasBonificaciones] = useState(true);

  const [disableCrearOrden, setDisableCrearOrden] = useState(true);

  const [newItem, setNewItem] = useState(null);

  const [roles, setRoles] = useState([]);
  const [ordenSubtotal, setOrdenSubtotal] = useState(0);
  const [ordenDescuento, setOrdenDescuento] = useState(0);

  const [errorCantidad, setErrorCantidad] = useState("");

  const [ordenTotal, setOrdenTotal] = useState(0);
  const [parcialidadTotal, setParcialidadTotal] = useState(0);

  const [productosAgregados, setProductosAgregados] = useState([]);

  const [creditoSuperado, setCreditoSuperado] = useState(false);
  const [asociadoCongelado, setAsociadoCongelado] = useState(false);

  const { clearTimers, addAlert } = useTimeout();

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    setProductosAgregados([]);
    setProductos([]);

    setOrdenDescuento([]);

    setOrdenSubtotal(0);
    setOrdenTotal(0);

    //refAutocompleteProducto.current.clearInput();
    refAutocompleteOrdenesVenta.current.clearInput();

    setNewItem(item);

    formik?.resetForm();

    loadItem(item);
  }, [item]);

  const fetchData = async () => {
    /*const responseMetodoPagos = await api.asociados().catch((e) => {
      toast.error("Error al pedir Metodo de Pagos.");
    });
    if (!responseMetodoPagos) return;

    setMetodoPagos(responseMetodoPagos.data);*/

    const response = await api.asociados().catch((e) => {
      toast.error("Error al pedir asociados.");
    });
    if (!response) return;

    const autoAsociados = response.data.map((item) => {
      const text = buildNameWithId(item, item.numAsociado);
      return { id: item.id, nombre: text, info: item };
    });

    setAsociados(autoAsociados);

    api
      .tiposEntrega()
      .then((response) => {
        setRoles([
          { id: 0, nombre: "Selecciona un Tipo de Entrega..." },
          ...response.data,
        ]);

        console.log(response.status);
      })
      .catch((e) => {
        console.log(e); // "oh, no!"
      });

    console.log(response.status);
  };

  const searchFetchData = async (text) => {
    const criteria = {
      isActivo: true,
      texto: text,
      page: 1,
      pageSize: 25,
    };

    const responseProductos = await api.searchProductos(criteria).catch((e) => {
      toast.error("Error al pedir producto.");
    });
    if (!responseProductos) return;

    setProductos(responseProductos.data.subset);
  };

  useEffect(() => {
    formik?.resetForm();

    fetchData();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  let initialValues = {
    id: 0,

    apartado: false,

    clienteId: null,
    asociadoId: 0,

    tipoEntregaId: 1,
    subTotalVenta: 0,
    descuento: 0,
    totalVenta: 0,
    ordenVentaDetalles: [],

    cantidad: 0,
  };

  if (!createMode) {
    initialValues = {
      id: item.id,

      clienteId: item.itemCliente?.cliente?.id,
      asociadoId: item.asociado.id,

      /*  clienteId: item.cliente?.id,
      asociadoId: item.asociado.id,
      tipoEntregaId: item.tipoEntrega.id,
      subTotalVenta: item.subTotalVenta,
      descuento: item.descuento,
      totalVenta: item.totalVenta,
      ordenVentaDetalles: item.ordenVentaDetalles,

      apartado: item.estadoBodega.id === EstadoBodega.Apartado,*/
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: createOrdenFormValidation,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      if (values.clienteId === 0) values.clienteId = null;

      // normalize
      const ordenVentaDetalles = productosAgregados.map((item) => {
        return {
          ordenVentaId: 0,
          productoId: item.id,
          cantidad: item.cantidad,
          precio: item.precio,
          total: item.total,
          subTotal: item.subTotal,
          descuento: item.descuento,
          promocionId: item.promocionId,
        };
      });

      values.totalVenta = ordenTotal;
      values.subTotalVenta = ordenSubtotal;

      values.ordenVentaDetalles = ordenVentaDetalles;

      /* default es En proceso Id = 1
      apartado = 2
      */
      const estadoBodegaId = formik.values.apartado
        ? EstadoBodega.Apartado
        : EstadoBodega.EnProceso;
      values.estadoBodegaId = estadoBodegaId;

      if (values.id === 0) {
        setIsLoading(true);
        const toastId = toast.loading("Creando Orden de Venta...");
        let response = await api.createOrdenVenta(values).catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Orden de Venta. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Orden de Venta.");
          setIsLoading(false);
        });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Orden de Venta creado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Orden...");
        setIsLoading(true);
        const response = await api.updateOrdenesVentas(values).catch((e) => {
          setIsLoading(false);
          toast.dismiss(toastId);
          toast.error("Error al actualizar Orden.");
        });
        if (!response) return;

        toast.dismiss(toastId);
        setIsLoading(false);

        toast.success("Orden actualizado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  function addProduct(e) {
    const cantidad = parseInt(formik.values.cantidad);

    if (isNaN(cantidad)) {
      toast.error(
        "Error al pedir agregar producto. Cantidad debe de contener solo numeros",
      );
      return;
    }

    let item = null;
    const itemAgregadoIndex = productosAgregados.findIndex(
      (item) => item.id === formik.values.productId,
    );
    if (itemAgregadoIndex === -1) {
      item = productos.find((item) => item.id === formik.values.productId);
      if (item == null) {
        toast.error("Error al pedir agregar producto.");
        return;
      }
    } else {
      item = productosAgregados[itemAgregadoIndex];
    }

    item.cantidad = cantidad;
    item.precio = item.precioVenta;
    item.subTotal = item.cantidad * item.precio;
    item.total = item.subTotal;

    let newProductosAgregados = [...productosAgregados];
    if (itemAgregadoIndex === -1) {
      newProductosAgregados.push(item);
    }

    setProductosAgregados(newProductosAgregados);

    formik.setFieldValue("ordenVentaDetalles", newProductosAgregados);

    calculateTotals(newProductosAgregados);

    /*
      const id = e == null ? 0 : parseInt(e.id);
                            formik.setFieldValue("productId", id);

                            formik.setFieldValue("productSelected", e);*/

    formik.setFieldValue("cantidad", 0); //formik.values.cantidad);
    formik.setFieldValue("ordenVentaId", "");
    formik.setFieldValue("productSelected", null);

    //refAutocompleteProducto.current.clearInput();
    refAutocompleteOrdenesVenta.current.clearInput();
  }

  function removeProduct(index) {
    if (index === -1) {
      return;
    }

    let newProductosAgregados = [...productosAgregados];
    newProductosAgregados.splice(index, 1);

    formik.setFieldValue("ordenVentaDetalles", newProductosAgregados);

    setProductosAgregados(newProductosAgregados);

    calculateTotals(newProductosAgregados);
  }

  function updateProduct(index, newAbono) {
    if (index === -1) {
      return;
    }

    let producto = productosAgregados[index];
    producto.abono = newAbono;
    //  producto.subTotal = producto.cantidad * producto.precio;
    //  producto.total = producto.subTotal;

    let newProductosAgregados = [...productosAgregados];

    formik.setFieldValue("ordenVentaDetalles", newProductosAgregados);

    setProductosAgregados(newProductosAgregados);

    calculateTotals(newProductosAgregados);
  }

  const calculateTotals = (productosAgregados) => {
    const initialValue = 0;
    const sums = productosAgregados.reduce(
      (accumulator, currentValue) => accumulator + currentValue.total,
      initialValue,
    );

    //item.total = item.cantidad * item.precio;
    const descuento = productosAgregados.reduce((accumulator, currentValue) => {
      currentValue.descuento = 0;
      currentValue.promocionId = null;

      console.log("---> XXX ");
      if (
        currentValue.bonificaciones == null ||
        currentValue.bonificaciones?.length === 0
      )
        return accumulator;

      const promocion = currentValue.bonificaciones[0];
      const promocionDetalle = promocion.promocionDetalles[0];

      if (sums < promocionDetalle.compraMinima) {
        return accumulator;
      }

      const descuento = currentValue.total * (promocionDetalle.descuento / 100);
      currentValue.descuento = descuento;
      currentValue.total = currentValue.subTotal - descuento;
      currentValue.promocionId = promocion.id;

      return accumulator + descuento;
    }, 0);

    setOrdenSubtotal(sums);
    setOrdenDescuento(descuento);

    const total = sums - descuento;
    setOrdenTotal(total);

    validateOrder();
  };

  useEffect(() => {
    validateOrder();
  }, [ordenTotal]);

  const validateOrder = () => {
    validateAsociadoCredito();
    validateAsociadoCongelado();
  };

  const validateAsociadoCongelado = () => {
    if (asociadoIdRef.current === 0) {
      setAsociadoCongelado(false);
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      return;
    }
    setAsociadoCongelado(asociado.info?.congelado ?? false);
  };

  const validateAsociadoCredito = () => {
    if (asociadoIdRef.current === 0) {
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      return;
    }

    const creditoDisponible = asociado.info?.creditoDisponible;

    const superado = ordenTotal > creditoDisponible;
    setCreditoSuperado(superado);
  };

  const clientFetch = async (asociadoId) => {
    if (asociadoId === 0) {
      setClientes([]);
      return;
    }
    const response = await api.asociadoClientes(asociadoId).catch((e) => {
      toast.error("Error al pedir asociados clientes.");
    });
    if (!response) return;

    const autoClientes = response.data.clientes.map((item) => {
      const text = buildNameWithId(item, item.numCliente);
      return { id: item.id, nombre: text };
    });

    setClientes(autoClientes);

    console.log(response.status);
  };

  function loadItem(newLoadItem) {
    const isEmpty = newLoadItem && Object.keys(newLoadItem).length === 0;
    if (isEmpty) {
      return;
    }

    refAutocompleteOrdenesVenta.current.clearInput();
    //refAutocompleteProducto.current.clearInput();
    //  refAutocompleteAsociados.current.clearInput();
    refAutocompleteClientes.current.clearInput();

    /*const ordenVentaDetalles = newItem.ordenVentaDetalles.map((item) => {
      return {
        id: item.productoId,
        cantidad: item.cantidad,
        precio: item.precio,
        total: item.total,
        subTotal: item.subTotal,
        descuento: item.descuento,
        promocion: item.promocion,
        ...item.producto,
      };
    });*/

    //  setProductosAgregados(ordenVentaDetalles);

    //  calculateTotals(ordenVentaDetalles);

    if (newLoadItem == null) {
      return;
    }
    clientFetch(newLoadItem.asociado?.id);
    formik.setFieldValue("clienteId", newLoadItem.cliente?.id);

    const autoOrdenes = newLoadItem.itemCliente.ordenParcialidades.map(
      (item) => {
        //  const text = buildNameWithId(item, item.numCliente);
        return { id: item.id, nombre: `Orden #${item.id.toString()}` };
      },
    );

    setOrdenesVenta(autoOrdenes);
  }

  function loadClienteItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createClientesRef);
    setModalData(item);
    setDefaultOnlyAsociadoId(formik.values.asociadoId);

    createClientesRef.current.toggleModal();
  }

  function loadBonoficacionItem(item) {
    if (!permissions.canVerDetalle) return;

    let asociado = asociados.find(
      (item) => item.id === formik.values.asociadoId,
    );
    let cliente = clientes.find((item) => item.id === formik.values.clienteId);

    setModalDataBonificacion({ producto: item, asociado, cliente });

    selectBonificacionRef.current.toggleModal();
  }

  function onChangeBonoficacion(infos, promocion) {
    console.log("---onChangeBonoficacion");

    const foundIndex = productosAgregados.findIndex((currItem) => {
      return currItem === modalDataBonificacion.producto;
    });

    if (foundIndex < 0) return;

    let newProductosAgregados = [...productosAgregados];
    newProductosAgregados[foundIndex].bonificaciones = [promocion];

    setProductosAgregados(newProductosAgregados);

    setHasBonificaciones(true);

    calculateTotals(newProductosAgregados);
  }

  function validateAgregarProducto(cantidadRaw, productIdRaw) {
    let cantidad = parseInt(cantidadRaw);
    let productoId = parseInt(productIdRaw);
    cantidad = isNaN(cantidad) ? 0 : cantidad;
    productoId = isNaN(productoId) ? 0 : productoId;

    const isAvailable =
      (formik.values.productSelected?.option?.cantidad ?? 0) >= cantidad;

    setDisableAgregarProducto(cantidad <= 0 || productoId <= 0 || !isAvailable);
    //{...formik.getFieldProps("cantidad")}

    const item = productos.find((item) => item.id === formik.values.productId);
    if (item == null) {
      //  toast.error("Error al pedir agregar producto.");
      return;
    }

    let newErrorCantidad =
      item.cantidad < cantidad
        ? "No existe cantidad suficiente en inventario"
        : "";
    setErrorCantidad(newErrorCantidad);
  }

  function loadOrdenVenta(orderId) {
    if (newItem == null) return;
    const ordenVentaDetalles = newItem.itemCliente.ordenParcialidades.find(
      (p) => p.id === orderId,
    );
    if (ordenVentaDetalles == null) {
      return;
    }

    /*
      (orden) => {
        return {
          id: item.productoId,
          cantidad: item.cantidad,
          precio: item.precio,
          total: item.total,
          subTotal: item.subTotal,
          descuento: item.descuento,
          promocion: item.promocion,
          ...item.producto,
        };
      },
    );*/

    setProductosAgregados(ordenVentaDetalles.ordenVenta.ordenVentaDetalles);

    setParcialidadTotal(ordenVentaDetalles.ordenVenta.ordenVentaDetalles);
    //
    let cantidad = 0; //parseInt(cantidadRaw);
    let productoId = 0; //parseInt(productIdRaw);
    cantidad = isNaN(cantidad) ? 0 : cantidad;
    productoId = isNaN(productoId) ? 0 : productoId;

    const isAvailable =
      (formik.values.productSelected?.option?.cantidad ?? 0) >= cantidad;

    setDisableAgregarProducto(cantidad <= 0 || productoId <= 0 || !isAvailable);
    //{...formik.getFieldProps("cantidad")}

    const item = productos.find((item) => item.id === formik.values.productId);
    if (item == null) {
      //  toast.error("Error al pedir agregar producto.");
      return;
    }

    let newErrorCantidad =
      item.cantidad < cantidad
        ? "No existe cantidad suficiente en inventario"
        : "";
    setErrorCantidad(newErrorCantidad);
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  function invalidateBonificacion() {
    productosAgregados.forEach((producto, index, other) => {
      if (
        producto.bonificaciones == null ||
        producto.bonificaciones?.length === 0
      )
        return;

      const promocion = producto.bonificaciones[0];
      const promocionDetalle = promocion.promocionDetalles[0];
    });

    /*
      promos solo asociados, poniendo cliente preguntar si seguir
      */
    /*   let isEnabled =
          [1, 2, 3].includes(info.id) &&
          item?.asociado != null &&
          item?.cliente == null;

*/

    /* promo para asociado en especial, seleccionando cliente o cambiando asociado , preguntar */
    /*    if (
            [6].includes(info.id) &&
            item?.asociado != null &&
            item?.cliente == null &&
            info.promocionDetalles &&
            info.promocionDetalles.length > 0
          ) {
            const promocionDetalle = info.promocionDetalles[0];

            const paraAsociadoId = promocionDetalle.asociado?.id;
            isEnabled = item?.asociado.id === paraAsociadoId;
          }*/

    /*if (sums < promocionDetalle.compraMinima) {

      }*/

    //  })*/

    /*
      const descuento = productosAgregados.reduce((accumulator, currentValue) => {
      console.log("---> XXX ");
      if (
        currentValue.bonificaciones == null ||
        currentValue.bonificaciones?.length === 0
      )
        return accumulator;

      const promocion = currentValue.bonificaciones[0];
      const promocionDetalle = promocion.promocionDetalles[0];

      if (sums < promocionDetalle.compraMinima) {
        return accumulator;
      }
*/

    /*      let isEnabled =
          [1, 2, 3].includes(info.id) &&
          item?.asociado != null &&
          item?.cliente == null;

        if (!isEnabled) {
          if (
            [6].includes(info.id) &&
            item?.asociado != null &&
            item?.cliente == null &&
            info.promocionDetalles &&
            info.promocionDetalles.length > 0
          ) {
            const promocionDetalle = info.promocionDetalles[0];

            const paraAsociadoId = promocionDetalle.asociado?.id;
            isEnabled = item?.asociado.id === paraAsociadoId;
          }
        }*/
  }

  /*
  function me(e) {
    console.log(e);
  }*/

  const formattedSubtotal = Singleton.getInstance().format(ordenSubtotal);
  const formattedDescuento = Singleton.getInstance().format(ordenDescuento);
  const formattedTotal = Singleton.getInstance().format(ordenTotal);

  console.log("--> CREATEORDEN Draw");
  const qtyTotal = productosAgregados.reduce(function (count, item, index) {
    count += item.cantidad;
    return count;
  }, 0);

  const disponiblesText =
    formik.values.productSelected != null
      ? `Disponible ${formik.values.productSelected.option.cantidad}`
      : "Disponible - ";

  return (
    <>
      <CreateClient
        ref={createClientesRef}
        item={modalData}
        defaultAsociadoId={defaultOnlyAsociadoId}
        returnBack={(e) => {
          modalRef.current.click();
        }}
        reloadClientes={(infos) => {
          if (infos == null) {
            return;
          }

          const { newClienteId, newAsociadoId } = infos;

          /*  const item = asociados.find((item) => item.id === newAsociadoId);
      if (item == null) {
        toast.error("Error al pedir agregar producto.");
        return;
      }*/

          console.log("2");
          formik.setFieldValue("asociadoId", newAsociadoId);
          asociadoIdRef.current = newAsociadoId;
          clientFetch(newAsociadoId);
          formik.setFieldValue("clienteId", newClienteId);
        }}
      />
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropCrearAbono"
        hidden
      >
        Abrir Crear Orden
      </button>

      <div
        className="modal fade modal-xl"
        id="staticBackdropCrearAbono"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropCrearAbonoLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                {createMode ? "Crear" : "Editar"} Pago
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="form-control">
                  {creditoSuperado && (
                    <div className="alert alert-danger" role="alert">
                      El total de la orden de venta <b>supera</b> el credito
                      para el asociado.
                    </div>
                  )}
                  {asociadoCongelado && (
                    <div className="alert alert-danger" role="alert">
                      No se puede realizar una Orden de Venta a un Asociado que
                      se encuentra en Estatus Congelado
                      <span>
                        <img
                          alt=""
                          src={SVGImages.SNOWFLAKE}
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "5px",
                          }}
                        />
                      </span>
                    </div>
                  )}
                  <h5>Información General</h5>

                  <div className="row">
                    <div className="col-3 align-self-start">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Metodo de Pago
                      </label>

                      <select
                        className="form-select"
                        aria-label="Default select example"
                      >
                        <option disabled="disabled" default="true">
                          Selecciona un Metodo de Pago
                        </option>
                        {metodoPagos.map((value, index) => {
                          const name = value.name;
                          const metodoId = value.id;

                          return <option value={metodoId}>{name}</option>;
                        })}
                      </select>

                      {/**   <AutocompleteGo
                      ref={refAutocompleteAsociados}
                      options={asociados}
                      placeholder="Buscar asociado..."
                      className={`form-select ${invalidClass(
                        formik.errors.asociadoId
                      )}`}
                      value={formik.values.asociadoId}
                      onChange={(e) => {
                        //formik.setFieldValue("sucursal", e);
                        console.log(e);
                        const id = e == null ? 0 : parseInt(e.id);
                        formik.setFieldValue("asociadoId", id);
                        asociadoIdRef.current = id;

                        setDisableCrearAbono(id === 0);
                        formik.setFieldValue("clienteId", 0);

                        invalidateBonificacion();
                        validateOrder();

                        clientFetch(id);
                      }}
                      readOnly={!createMode}
                    >
                      <div className="valid-feedback">Looks good!</div>
                      <div className="invalid-feedback">
                        {formik.errors.asociadoId}
                      </div>
                    </AutocompleteGo>
                    */}
                    </div>

                    <div className="col-2">
                      <label
                        htmlFor="exampleInputEmail1"
                        className="form-label"
                      >
                        Cantidad
                      </label>
                      <input
                        type="number"
                        min="0"
                        max="20"
                        className={`form-control ${invalidClass(
                          errorCantidad,
                        )}`}
                        style={{ textAlign: "center" }}
                        id="validationName"
                        aria-describedby="emailHelp"
                        value={formik.values.cantidad}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "cantidad",
                            e.currentTarget.value,
                          );
                          //{...formik.getFieldProps("cantidad")}

                          validateAgregarProducto(
                            e.currentTarget.value,
                            formik.values.productId,
                          );
                        }}
                      />
                      <div
                        className="valid-feedback"
                        style={{ display: "flex" }}
                      >
                        {disponiblesText}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col align-self-start">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Asociado
                        </label>
                        <AutocompleteGo
                          ref={refAutocompleteAsociados}
                          options={asociados}
                          placeholder="Buscar asociado..."
                          className={`form-select ${invalidClass(
                            formik.errors.asociadoId,
                          )}`}
                          value={formik.values.asociadoId}
                          onChange={(e) => {
                            //formik.setFieldValue("sucursal", e);
                            console.log(e);
                            const id = e == null ? 0 : parseInt(e.id);
                            formik.setFieldValue("asociadoId", id);
                            asociadoIdRef.current = id;

                            setDisableCrearOrden(id === 0);
                            formik.setFieldValue("clienteId", 0);

                            validateOrder();

                            clientFetch(id);
                          }}
                          readOnly={true}
                        >
                          <div className="valid-feedback">Looks good!</div>
                          <div className="invalid-feedback">
                            {formik.errors.asociadoId}
                          </div>
                        </AutocompleteGo>
                      </div>
                    </div>

                    <div className="align-items-end">
                      <div className="col-9">
                        <label
                          htmlFor="validationApellidoPaterno"
                          className="form-label"
                        >
                          Cliente
                        </label>
                        <AutocompleteGo
                          ref={refAutocompleteClientes}
                          options={clientes}
                          placeholder="Buscar Cliente..."
                          className={`form-select ${invalidClass(
                            formik.errors.clienteId,
                          )}`}
                          value={formik.values.clienteId}
                          onChange={(e) => {
                            //formik.setFieldValue("sucursal", e);
                            console.log(e);
                            const id = e == null ? 0 : parseInt(e.id);
                            formik.setFieldValue("clienteId", id);

                            invalidateBonificacion();
                          }}
                          readOnly={true}
                        >
                          <div className="valid-feedback">Looks good!</div>
                          <div className="invalid-feedback">
                            {formik.errors.clienteId}
                          </div>
                        </AutocompleteGo>
                      </div>

                      {/**   <div className="col">
                        <button
                          className="btn btn-primary"
                          type="button"
                          id="button-addon2"
                          onClick={(event) => loadClienteItem({})}
                          disabled={!createMode}
                        >
                          Crear cliente
                        </button>
                      </div> */}
                    </div>

                    {/* <div className="row">
                      <div className="col-9">
                        <label
                          htmlFor="exampleInputEmail1"
                          className="form-label"
                        >
                          Tipo de Entrega
                        </label>
                        <select
                          className={`form-control ${invalidClass(
                            formik.errors.tipoEntregaId,
                          )}`}
                          id="inputGroupSelect01"
                          {...formik.getFieldProps("tipoEntregaId")}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "tipoEntregaId",
                              parseInt(e.target.value),
                            );
                          }}
                          disabled={!createMode}
                        >
                          {roles.map((item) => {
                            return (
                              <option value={item.id}>{item.nombre}</option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col " style={{ alignContent: "end" }}>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexSwitchCheckApartadoDefault"
                            {...formik.getFieldProps("apartado")}
                            checked={formik.values.apartado}
                            disabled={!createMode}
                          />
                          <span>
                            <label
                              className="form-check-label"
                              htmlFor="flexSwitchCheckApartadoDefault"
                            >
                              Apartado
                            </label>
                          </span>
                        </div>
                      </div>
                    </div> */}
                  </div>

                  <div className="separator" style={{ marginTop: "15px" }}>
                    <div className="mb-3">
                      <div className="row">
                        <div className="col">
                          <label
                            htmlFor="validationApellidoPaterno"
                            className="form-label"
                          >
                            Ordenes de Venta
                          </label>

                          <AutocompleteGo
                            ref={refAutocompleteOrdenesVenta}
                            options={ordenesVenta}
                            liveMode={true}
                            placeholder="Buscar número de Orden..."
                            className={`form-select ${invalidClass(
                              formik.errors.ordenVentaDetalles,
                            )}`}
                            onChange={(e) => {
                              if (item == null) return;
                              //formik.setFieldValue("sucursal", e);
                              console.log("-->onChange create Orden");
                              const id = e == null ? 0 : parseInt(e.id);
                              formik.setFieldValue("ordenVentaId", id);

                              //formik.setFieldValue("productSelected", e);

                              /*  validateAgregarProducto(
                                formik.values.cantidad,
                                id,
                              );*/

                              loadOrdenVenta(id);
                            }}
                            onInputChanged={(e) => {
                              //formik.setFieldValue("sucursal", e);

                              clearTimers();

                              addAlert(() => {
                                formik.setFieldValue("productoValue", e);
                                searchFetchData(e);
                              });
                            }}
                          >
                            <div className="valid-feedback">Looks good!</div>
                            <div
                              className="invalid-feedback"
                              style={{ display: "flex" }}
                            >
                              {errorCantidad}
                            </div>
                          </AutocompleteGo>
                        </div>
                        <div className="col">
                          <label
                            htmlFor="validationApellidoPaterno"
                            className="form-label"
                          >
                            Parcialidad Actual
                          </label>

                          <div className="input-group mb-3">
                            <span
                              className="input-group-text"
                              id="basic-addon1"
                            >
                              $
                            </span>
                            <span
                              className="input-group-text"
                              id="basic-addon1"
                            >
                              {parcialidadTotal}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row ">
                        <div className="valid-feedback"></div>
                      </div>
                      <div className="row">
                        <div className="container">
                          <div
                            className="separator"
                            style={{ marginTop: "15px" }}
                          >
                            <table className="table caption-top">
                              <caption>Lista de productos</caption>
                              <thead>
                                <tr>
                                  <th scope="col">Nombre</th>
                                  <th scope="col">Marca</th>
                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Precio
                                  </th>
                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Cantidad
                                  </th>
                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    Total
                                  </th>
                                  {/**   <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                    className="no-sort"
                                  >
                                    Acciones
                                  </th>
                                  */}

                                  <th
                                    scope="col"
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                    className="no-sort"
                                  >
                                    Abono
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {productosAgregados.map((item, index) => {
                                  const nombre = item.producto?.nombre;
                                  const marca =
                                    item.producto?.marca?.nombre ?? "";

                                  const precio = Singleton.getInstance().format(
                                    item.precio,
                                  );
                                  const cantidad = item.cantidad;
                                  const abono = item.abono;
                                  const subTotal =
                                    Singleton.getInstance().format(
                                      item.subTotal,
                                    );

                                  return (
                                    <>
                                      <tr
                                        className={`${createOrdenStyles.tablecenter}`}
                                      >
                                        <th scope="row">{nombre}</th>
                                        <td>{marca}</td>
                                        <td
                                          style={{
                                            textAlign: "center",
                                          }}
                                        >
                                          {precio}
                                        </td>
                                        <td>
                                          <div
                                            style={{
                                              position: "relative",
                                              width: "100%",
                                              display: "block",
                                            }}
                                          >
                                            <input
                                              style={{
                                                width: "100%",
                                                textAlign: "center",
                                              }}
                                              type="number"
                                              min="1"
                                              step="1"
                                              value={cantidad}
                                              onChange={(e) => {
                                                //
                                                updateProduct(
                                                  index,
                                                  parseInt(
                                                    e.currentTarget.value,
                                                  ),
                                                );
                                              }}
                                              disabled={true}
                                            />
                                          </div>
                                        </td>

                                        <td
                                          style={{
                                            textAlign: "center",
                                          }}
                                        >
                                          {subTotal}
                                        </td>

                                        <td>
                                          <div
                                            style={{
                                              position: "relative",
                                              width: "100%",
                                              display: "block",
                                            }}
                                          >
                                            <input
                                              style={{
                                                width: "100%",
                                                textAlign: "center",
                                              }}
                                              type="text"
                                              min="1"
                                              step="1"
                                              value={abono}
                                              onChange={(e) => {
                                                //
                                                updateProduct(
                                                  index,
                                                  parseInt(
                                                    e.currentTarget.value,
                                                  ),
                                                );
                                              }}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    </>
                                  );
                                })}

                                <tr>
                                  <td
                                    colSpan="3"
                                    style={{
                                      textAlign: "right",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Cantidad Total :
                                  </td>
                                  <td
                                    style={{
                                      width: "100px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {qtyTotal}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>

                            <div className="valid-feedback"></div>
                            <div className="invalid-feedback">
                              {formik.errors.productosCantidad}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-control">
                  <h5>Sumario</h5>
                  <div className="row">
                    <table className="table caption-top">
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th scope="col"></th>
                          <th
                            scope="col"
                            style={{ width: "100px", textAlign: "center" }}
                          ></th>
                          <th
                            scope="col"
                            style={{ width: "100px", textAlign: "center" }}
                          ></th>
                          <th
                            scope="col"
                            style={{ width: "100px", textAlign: "center" }}
                            className="no-sort"
                          ></th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td colSpan={6} style={{ textAlign: "right" }}>
                            SubTotal :
                          </td>
                          <td style={{}}>{formattedSubtotal}</td>
                        </tr>
                        {hasBonificaciones && (
                          <tr>
                            <td colSpan={6} style={{ textAlign: "right" }}>
                              Bonificación :
                            </td>
                            <td>{formattedDescuento}</td>
                          </tr>
                        )}
                        {/*<tr>
                          <th scope="row">Shipping Cost :</th>
                          <td>$126.20</td>
                        </tr>*/}
                        <tr></tr>
                        <tr
                          style={{
                            borderTopWidth: "2px",
                            borderStyle: "dashed",
                            borderTopColor: "black",
                          }}
                        >
                          <td colSpan={6} style={{ textAlign: "right" }}>
                            Total :
                          </td>
                          <td style={{}}>{formattedTotal}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cancelar
                  </button>
                  {
                    <LoadingButton
                      style={{ height: "38px" }}
                      onClick={(e) => {
                        formik.handleSubmit();
                      }}
                      text={"Guardar"}
                      loadingText={"Guardando..."}
                      isLoading={isLoading}
                      isDisable={creditoSuperado || asociadoCongelado}
                    />
                  }
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <SelectBonificacion
        ref={selectBonificacionRef}
        item={modalDataBonificacion}
        returnToModalId="staticBackdropCrearAbono"
        onChange={onChangeBonoficacion}
      />
    </>
  );
});

export default CreateAbono;
